import type { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { Navigate, useLocation } from 'react-router';
import { userStore } from '../../auth/store';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = observer(({ children }: ProtectedRouteProps) => {
  const location = useLocation();

  if (userStore.isInitialising) {
    return <div className="mgo-cluster mgo-justify-center mgo-color-muted" style={{ minHeight: '100vh' }}>Loading...</div>;
  }

  if (!userStore.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
});
